import { useEffect } from 'react';
import { API_ROUTES, HOST } from './constants/apiRoutes';

function useTitle(title) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}


function getFlashContainer() {
    return document.getElementById('flashMessages');
}

function addFlashMessage(level, message, canClose) {
    if (level === 'error') {
        level = 'danger';
    }
    const container = getFlashContainer();
    if (!container) {
        return;
    }
    let template = '<div class="alert alert-' + level + '">';
    template += message;
    template += '</div>';
    container.insertAdjacentHTML('beforeend', template);
}

function setFlashMessage(level, message, canClose = true) {
    clearFlashMessages();
    addFlashMessage(level, message, canClose);
}

function clearFlashMessages() {
    const container = getFlashContainer();
    if (container) {
        container.innerHTML = '';
    }
}

function userIsLogged() {
    return new Promise((resolve, reject) => {
        fetch(API_ROUTES.IS_LOGGED, {
            method: 'GET',
        }).then(response => response.json()).then((data) => {
            if (data && data.isLogged === true) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch((error) => {
            console.error('Error:', error)
            resolve(false)
        })
    })
}

function userRedirectLogin() {
    window.location.href = HOST + '/common/login?red=' + encodeURIComponent(window.location.pathname)

}

export {
    useTitle,
    setFlashMessage,
    clearFlashMessages,
    userIsLogged, 
    userRedirectLogin
}